import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, Modal } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import Select from 'react-select'

import { Link, useHistory, useParams } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import { PAS_X, CLOSE_PA, PA_LINES, PA_LINES2, EMPLOYEES, SEND2APPRAISER, MPA_LINES, MPA_LINES2, MPA_LINES4 } from 'helpers/url_helper';
import * as url from "../../helpers/url_helper"
 
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Timeline from './Timeline';



    const PADetails = () => {
        const {id} = useParams();
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [apType , setApType] = useState(['Annual', 'Probation'])
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')
        const [ipaStatus, setIpaStatus] = useState('')
        const [ipaDate, setIpaDate] = useState('')
        const [ipaPerformanceYear, setIpaPerformanceYear] = useState('')
        const [ipaConvert, setIpaConvert] = useState('')
        const [appraisalPeriod, setAppraisalPeriod] = useState('')
        const [appraiserNo, setAppraiserNo] = useState('')
        const [appraiserName, setAppraiserName] = useState('')
        const [appraiserTitle, setAppraiserTitle] = useState('')
        const [documentType, setDocumentType] = useState('')
        const [departmentCode, setDepartmentCode] = useState('')
        const [performanceType, setPerformanceType] = useState('')
        const [cycle, setCycle] = useState('')
        const [phase, setPhase] = useState('')
        const [lines, setLines] = useState([])
        const [lines2, setLines2] = useState([])

        const [whoAmI, setWhoAmI] = useState('')
        const [st, setSt] = useState('')

        const [aps, setAps] = useState(0)
        const [abs, setABs] = useState(0)
        const [oaps, setOAps] = useState(0)
        const [oabs, setOABs] = useState('')

        const [pps, setPps] = useState(0)
        const [pbs, setPbs] = useState(0)

        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');

        const [supervisorNo, setSupervisorNo] = useState('')
        const [supervisorName, setSupervisorName] = useState('')
        const [supervisorTitle, setSupervisorTitle] = useState('')
        const [CompanyID, setCompanyID] = useState("")

        const [isEdit, setIsEdit] = useState(false)
        const [lineSystemId, setLineSystemId] = useState('')

        const [kra, setKra] = useState('')
        const [target, setTarget] = useState('')
        const [kpi, setKpi] = useState('')
        const [resources, setResources] = useState('')

        const [cCode, setCCode] = useState('')
        const [competenciesDescription, setCompetenciesDescription] = useState('')
        const [attributes, setAttributes] = useState('')
        const [kpi2, setKpi2] = useState('')
        const [kra2, setKra2] = useState('')
        const [resources2, setResources2] = useState('')

        const [support, setSupport] = useState('')
        const [plannedResults, setPlannedResults] = useState('')
        const [actualResults, setActualResults] = useState('')

        const [goal, setGoal] = useState('')
        const [method, setMethod] = useState('')
        const [application, setApplication] = useState('')
        const [competencies, setCompetencies] = useState([])
        const [kpi4, setKpi4] = useState('')
        const [kra4, setKra4] = useState('')

        const [midYearRemarks, setMidYearRemarks] = useState('')
        const [midYearStatus, setMidYearStatus] = useState(0)

        const [mpaLines1, setmpaLines1] = useState([])
        const [mpaLines2, setmpaLines2] = useState([])
        const [mpaLines3, setmpaLines3] = useState([])
        const [mpaLines4, setmpaLines4] = useState([])

        const [startDate, setStartDate] = useState('');
        const [endDate, setEndDate] = useState('');
        const [type, setType] = useState('');

        const [modal_mpa1, setmodal_mpa1] = useState(false)
        const [modal_mpa2, setmodal_mpa2] = useState(false)
        const [modal_mpa3, setmodal_mpa3] = useState(false)
        const [modal_mpa4, setmodal_mpa4] = useState(false)

        const [startDoing, setStartDoing] = useState('')
        const [stopDoing, setStopDoing] = useState('')
        const [continueDoing, setContinueDoing] = useState('')
        const [employeeComment, setEmployeeComment] = useState('')
        const [supervisorComment, setSupervisorComment] = useState('')

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_mpa1 = () => {
            setmodal_mpa1(!modal_mpa1);
            removeBodyCss();
        }
        const tog_mpa2 = () => {
            setmodal_mpa2(!modal_mpa2);
            removeBodyCss();
        }
        const tog_mpa3 = () => {
            setmodal_mpa3(!modal_mpa3);
            removeBodyCss();
        }
        const tog_mpa4 = () => {
            setmodal_mpa4(!modal_mpa4);
            removeBodyCss();
        }

        const clearData1 = () =>{
            setIsEdit(false)
            setKra('')
            setTarget('')
            setKpi('')
            setResources('')
            setLineSystemId('')
        }
        const clearData2 = () =>{
            setKpi2('')
            setKra2('')
            setLineSystemId('')
        }
        const clearData3 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setSupport('')
            setPlannedResults('')
            setActualResults('')
        }
        const clearData4 = () =>{
            setLineSystemId('')
            setIsEdit(false)
            setGoal('')
            setMethod('')
            setApplication('')
        }
    
        const savePA1 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                MidYearRemarks  : midYearRemarks,
                MidYearStatus   : parseInt(midYearStatus)
            }           
            axios.patch(`${MPA_LINES}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Score saved')
                tog_mpa1()
                clearData1()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }

        const savePA2 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                MidYearRemarks  : midYearRemarks,
                MidYearStatus   : parseInt(midYearStatus)
            }            
            axios.patch(`${MPA_LINES2}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Score saved')
                tog_mpa2()
                clearData2()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }

        

        const savePA4 = () =>{
            setIsloading(true)
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                MidYearRemarks  : midYearRemarks,
                MidYearStatus   : parseInt(midYearStatus)
            }            
            axios.patch(`${MPA_LINES4}(${lineSystemId})?company=${CompanyID}`, JSON.stringify(data), Config).then((r)=>{
                setIsloading(false)
                toastr.success('Score 4 saved')
                tog_mpa4()
                clearData4()
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }

        const handleClickLineDetails1 = (k) =>{
            setIsEdit(true)
            tog_mpa1()
            setKra(mpaLines1[k].KeyResultArea)
            setTarget(mpaLines1[k].statementofTargettobeachieved)
            setKpi(mpaLines1[k].KeyPerformanceIndicator)
            setResources(mpaLines1[k].resourcesandSupportRequired)
            setLineSystemId(mpaLines1[k].SystemId)
            setMidYearRemarks(mpaLines1[k].MidYearRemarks)
            setMidYearStatus(mpaLines1[k].MidYearStatus)
           
        }
        const handleClickLineDetails2 = (k) =>{
            tog_mpa2()
            setLineSystemId(mpaLines2[k].SystemId)
            setKra2(mpaLines2[k].KeyResultArea)
            setKpi2(mpaLines2[k].KeyPerformanceIndicator)
            setMidYearRemarks(mpaLines2[k].MidYearRemarks)
            setMidYearStatus(mpaLines2[k].MidYearStatus)
        }
        const handleClickLineDetails4 = (k) =>{
            tog_mpa4()
            console.log(mpaLines4[k])
            setLineSystemId(mpaLines4[k].SystemId)
            setKra4(mpaLines4[k].KeyResultArea)
            setKpi4(mpaLines4[k].KeyPerformanceIndicator)
            //setGoal(mpaLines4[k].DevelopmentGoalsIdentifiedlearningdevelopmentareas)
            //setMethod(mpaLines4[k].LearningDevelopmentMethodsHowwilltheLearningandDevelopmentbeachieved)
            //setApplication(mpaLines4[k].ApplicationWhatistheexpectedchangeinperformanceafteracquiringtheidentifiedskills)
            setMidYearRemarks(mpaLines4[k].MidYearRemarks)
            setMidYearStatus(mpaLines4[k].MidYearStatus)
        }

        const reports = [
            {
                icon: "bx bx-copy-alt",
                title: "Mid Year Competence Score",
                value: aps,
                badgeValue: "",
                color: "success",
                desc: "",
            },
            {
                icon: "bx bx-archive-in",
                title: "Mid Year Technical Score",
                value: abs,
                badgeValue: "",
                color: "success",
                desc: "",
            },
            {
                icon: "bx bx-copy-alt",
                title: "Overall Mid Year Assessment",
                value: oaps,
                badgeValue: "",
                color: "success",
                desc: "",
              }
          ];
         
  
        const fetchData = () => {
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            setCompanyID(obj.activeCompany);
            setIsloading(true)
            axios.get(`${url.MPAS}(${id})?$expand=mpaLines,mpaLines2,mpaLines4&company=${obj.activeCompany}`, HRConfig)
                .then(function(response){
                    setStartDoing(response.data.WhatshouldyoustartDoing)
                    setStopDoing(response.data.Whatshouldyoustopdoing)
                    setContinueDoing(response.data.Whatshouldyoucontinuedoing)
                    setEmployeeComment(response.data.employeeComments)
                    setSupervisorComment(response.data.directSupervisorComments)
                      //check who am i
                    //const obj = JSON.parse(localStorage.getItem("authMildUser"));
                    if(response.data.EmployeeNo == obj.uid){ setWhoAmI('appraisee'); }else if(response.data.Appraiser == obj.uid){ setWhoAmI('appraiser');  }

                    axios.get(`${EMPLOYEES}?$filter=No eq '${response.data.EmployeeNo}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{ 
                        setEmpName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setEmpTitle(r.data.value[0].JobTitle)
                    }).catch((e)=>{ console.log(e) })
                    axios.get(`${EMPLOYEES}?$filter=No eq '${response.data.Appraiser}'&company=${obj.activeCompany}`, HRConfig).then((r)=>{ 
                        setSupervisorName(r.data.value[0].FirstName +" "+r.data.value[0].LastName)
                        setSupervisorTitle(r.data.value[0].JobTitle)
                    }).catch((e)=>{ console.log(e) })
                    setEmpNo(response.data.EmployeeNo)
                
                    setSupervisorNo(response.data.Appraiser)
                    setDepartmentCode(response.data.DepartmentCode)
                    setIpaDate(response.data.Date)
                    setCycle(response.data.AppraisalCycle)
                    setIpaPerformanceYear(response.data.PerformanceYear)
                    setIpaStatus(response.data.Status)
                    setIpaConvert(response.data.ConvertToAppraisal)
                    setAppraisalPeriod(response.data.AppraisalPeriod)
                    setIpaNo(response.data.No)

                    setDocumentType(response.data.DocumentType)
                    setPerformanceType(response.data.PerformanceType)
                    setIpaDate(response.data.PostingDate)
                    setType(response.data.TypeofPerformanceAppraisal)
                    setStartDate(response.data.FromDate)
                    setEndDate(response.data.ToDate)
                    setPhase(response.data.Phase)
                    setmpaLines1(response.data.mpaLines)
                    setmpaLines2(response.data.mpaLines2)
                    setmpaLines4(response.data.mpaLines4)

                

                    setAps(response.data.AverageMidyearCompetencyScore.toFixed(2))
                    setABs(response.data.AverageMidyearTechnicalScore.toFixed(2))
                    setOAps(response.data.OverallMidyearAssessment.toFixed(2))
                    setOABs(response.data.OverallMidyearRemarks)
                    if(response.data.Phase == "Mid-Year"){
                        setSt(2);
                    }else if(response.data.Phase == "Full-Year"){
                        setSt(3);
                    }else if(response.data.Phase == "Closed"){
                        setSt(5);
                    } 
                    setIsloading(false)
                }).catch(function (error) {
                    //toastr.error(error.response.data.error.message);
                    setUserError(true);
                    setIsloading(false)
                })
                .then(function () {
            });
        }
        const handleUpdatePA = () =>{
            const Config = {
                auth: {
                    username: url.HRMIS,
                    password: url.HRMISPASS,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'If-Match'    : '*'
                }
            }
            const data = {
                WhatshouldyoustartDoing: startDoing,
                Whatshouldyoustopdoing: stopDoing,
                Whatshouldyoucontinuedoing: continueDoing,
                employeeComments : employeeComment,
                directSupervisorComments : supervisorComment
            }
            setIsloading(true)
            axios.patch(`${url.MPAS}(${id})`, JSON.stringify(data), Config).then((r)=>{
                toastr.success('Key reflection Questions saved')
                setIsloading(false)
                fetchData()
            }).catch((e)=>{
                console.log(e)
                setIsloading(false)
            })
        }
        useEffect(() => {
           fetchData();
        },[]);

      
        const handleConfirmMidTermJointReview = () =>{
            setIsloading(true)
            const lNo = {"no": ipaNo} 
            axios.post(url.CONFIRMMIDTERMJOINTREVIEW , JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    toastr.success(response.data.value)
                    history.push("/appraise-performance-appraisals")
                    fetchData()
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                    setIsloading(false)
            })
        }

        const handleConvertToFullYear = () =>{
            setIsloading(true)
            const lNo = {"no": ipaNo} 
            axios.post(url.CONVERTMID2FULLYEAR +'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){  
                    toastr.success(response.data.value)
                    history.push("/full-performance-appraisals")
                    //fetchData()
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                    setIsloading(false)
            })
        }
        const handleSendForApproval = () => {
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(url.SENDIPA4APPROVAL , JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success(response.data.value ); 
                        //window.location.reload();
                        fetchData()
                    }else{
                        toastr.success("Could not Post IPA" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                })
                .then(function () {
                // always executed
                setIsloading(false)
            });
        }
        const handleSendMidtermToAppraiser = () =>{
            setIsloading(true)
            const lNo = {"no": ipaNo} 
            axios.post(url.SENDMIDTERMTOAPPRAISER +'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    toastr.success(response.data.value)
                    fetchData()
                    setIsloading(false)
                    history.push("/performance-appraisals")
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                    setIsloading(false)
            })
        }
        const handleClosePA = () =>{
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(CLOSE_PA , JSON.stringify(lNo), HRConfig)
                .then(function(response){  
                    //console.log(response)   
                    if(response.status == '204'){
                        toastr.success("Appraisal Closed"); 
                        //window.location.reload();
                        fetchData()
                    }else{
                        toastr.success("Could not Close" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    console.log(error)
                })
                .then(function () {
                // always executed
                setIsloading(false)
            });
        }

        const handlePrint = () =>{
            setIsloading(true)
            const lNo = {'no': ipaNo}
            axios.post(url.PRINTAPPRAISAL, JSON.stringify(lNo), HRConfig).then((r)=>{
                fetch(r.data.value)
                .then(response => response.blob())
                .then(blob => {
                  const url = URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = 'yourPdfFile.pdf';
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                });
            }).catch((e)=>{
                console.log(e)
            })
        }
        return (
            <LoadingOverlay
            active={isloading}
            spinner={<BounceLoader />}
            text='Please wait...' >
            <div className="page-content">
            <MetaTags>
            <title>Performance Appraisal | Bridge</title>
            </MetaTags>
            <Container fluid={true}>
                <Breadcrumbs title="Human Resource Management" breadcrumbItem="Performance Appraisal" />
                <div>
             
                    <Row>
                        <Col md={12}>
                            <Alert color={(ipaStatus == "Pending Approval")?`warning`: ((ipaStatus == "Open")?`danger`:`success`) }><strong>{ipaStatus}</strong></Alert>
                        </Col>
                    </Row>
               
                
                                <Modal isOpen={modal_mpa1} toggle={tog_mpa1} size='xl' centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Technical Job Deliverables</h5>
                                    <button type="button" onClick={() => { setmodal_mpa1(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Result Area</label>
                                                <textarea rows={4} className="form-control" value={kra} onChange={(e)=>setKra(e.target.value)} disabled={true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea rows={4} className="form-control" value={kpi} onChange={(e)=>setKpi(e.target.value)} disabled={true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Statement of targets to be achieved</label>
                                                <textarea rows={4} className="form-control" value={target} onChange={(e)=>setTarget(e.target.value)} disabled={true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Resources and support required</label>
                                                <textarea rows={4} className="form-control" value={resources} onChange={(e)=>setResources(e.target.value)} disabled={true} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Mid-Year remarks</label>
                                                <textarea rows={4} className="form-control" value={midYearRemarks} onChange={(e)=>setMidYearRemarks(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Mid-Year status</label>
                                                <input type='number' className="form-control" value={midYearStatus} onChange={(e)=>setMidYearStatus(e.target.value)} />
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_mpa1() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    
                                    <button type="button" className="btn btn-success" onClick={savePA1}>Save Score...</button>
                                  </div>
                                  )}
                                </Modal>
                                <Modal isOpen={modal_mpa2} toggle={tog_mpa2} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Competence Targets</h5>
                                    <button type="button" onClick={() => { setmodal_mpa2(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                              
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key result areas</label>
                                                <textarea rows={4} className="form-control" value={kra2} onChange={(e)=>setKra2(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea rows={4} className="form-control" value={kpi2} onChange={(e)=>setKpi2(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Mid-Year remarks</label>
                                                <textarea rows={4} className="form-control" value={midYearRemarks} onChange={(e)=>setMidYearRemarks(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Mid-Year status</label>
                                                <input type='number' className="form-control" value={midYearStatus} onChange={(e)=>setMidYearStatus(e.target.value)} />
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_mpa2() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-success" onClick={savePA2}>Save Score...</button>
                                  </div>
                                  )}
                                </Modal>
                                
                                <Modal isOpen={modal_mpa4} toggle={tog_mpa4} centered size='xl'>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Short Term Development Needs</h5>
                                    <button type="button" onClick={() => { setmodal_mpa4(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        {/*<Col md={12}>
                                            <div className="mb-3">
                                                <label>Development Goal Identified</label>
                                                <input type="text" className="form-control" value={goal} onChange={(e)=>setGoal(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Learning Development Method</label>
                                                <input type="text" className="form-control" value={method} onChange={(e)=>setMethod(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Application</label>
                                                <input type="text" className="form-control" value={application} onChange={(e)=>setApplication(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        */}
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key performance indicator</label>
                                                <textarea rows={4} className="form-control" value={kpi4} onChange={(e)=>setKpi4(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key result areas</label>
                                                <textarea rows={4} className="form-control" value={kra4} onChange={(e)=>setKra4(e.target.value)} disabled={true}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Mid-Year remarks</label>
                                                <textarea rows={4} className="form-control" value={midYearRemarks} onChange={(e)=>setMidYearRemarks(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Mid-Year status</label>
                                                <input type='number' className="form-control" value={midYearStatus} onChange={(e)=>setMidYearStatus(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                  </Row>
                                  </div>
                                  {isloading?(
                                    <>
                                        <Alert className='m-4'><b>Please wait...</b></Alert>
                                    </>
                                  ):(
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={tog_mpa4} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-success" onClick={savePA4}>Save Line...</button>
                                  </div>
                                  )}
                                </Modal>
        


                
                <Row>
                    <Col  xl={3}>
                            <Timeline stage={st}/>
               

                        </Col>
               
                        <Col xl={9}>
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Details</h5>
                            <CardBody>
                   
                       
                                    <Row>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee No</label>
                                            <input type="text" className="form-control" disabled={true}  defaultValue = {empNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empName} />
                                        </div>
                                    </Col>
                                   
                              
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorNo} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorName} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorTitle}  />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                        <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Mid-term Details</h5>
                            <CardBody>
                     
                                <Row>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>No</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaNo}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Department Code</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={departmentCode}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Convert to PA</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaConvert}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Document Type</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={documentType}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Performance Year</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaPerformanceYear}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Phase</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={phase}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaStatus}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                            <label>Posting Date</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={ipaDate}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label>Type of Performance Appraisal</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={type}  />
                                        </div>
                                </Col>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label>Start Date</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={startDate}  />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>End Date</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={endDate}  />
                                        </div>
                                    </Col>
                                    
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Technical Job Deliverables ({mpaLines1.length})</h5>
                            <CardBody>
               
                                    {(mpaLines1.map((i,k)=>(
                                        <Row key={k}>
                                            
                                            <Col lg={8} className="mb-3">
                                               <h5>Line {k+1}</h5>
                                               <Row  className="m-1 mb-4">
                                                  <Col sm={12}><h5 className="text-primary">Key Result Area:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.KeyResultArea}</Col>
                                               </Row>
                                               <Row  className="m-1">
                                                  <Col sm={12}><h5 className="text-primary">Key Performance Indicator:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.KeyPerformanceIndicator}</Col>
                                               </Row>
                                               <Row  className="m-1">
                                                  <Col sm={12}><h5 className="text-primary">Statement of Target to be achieved:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.statementofTargettobeachieved}</Col>
                                               </Row>
                                               <Row  className="m-1">
                                                  <Col sm={12}><h5 className="text-primary">Resources and support required:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.resourcesandSupportRequired}</Col>
                                               </Row>
                                          </Col>
                                          <Col lg={4} className="mb-3">
                                          <h5>&nbsp;</h5>
                                              {(phase == 'Mid-Year') && (whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && ( 
                                            <Row className='justify-content-center'>
                                                <Col>
                                                    <div className="align-items-center">   
                                                        <Button
                                                            type="button"
                                                            color="info"
                                                            className="btn-sm btn-rounded m-3"
                                                            onClick={()=>handleClickLineDetails1(k)}
                                                            >
                                                            Appraiser ratings
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                             )}  
                                               <Row  className="m-1 mb-4">
                                                  <Col sm={12}><h5 className="text-primary">Mid Year remark:</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearRemarks}</Col>
                                               </Row>
                                               <Row  className="m-1">
                                                  <Col sm={12}><h5 className="text-primary">Appraiser Score</h5></Col>
                                                  <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearStatus}</Col>
                                               </Row>
                                          </Col>
                                          <Col sm={12}><hr/></Col>
                       
                                        </Row>
                                    )))}
                                    </CardBody>
                                </Card>
                                <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Competence Targets ({mpaLines2.length})</h5>
                                <CardBody>
                          
                          
                                    {(mpaLines2.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={8} className="mb-3">
                                                <h5>Line {k+1}</h5>
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">Key Result Area:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.KeyResultArea}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Key Performance Indicator:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.KeyPerformanceIndicator}</Col>
                                                </Row>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <h5>&nbsp;</h5>
                                                {(phase == 'Mid-Year') && (whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails2(k)}
                                                                >
                                                                Appraiser ratings
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}  
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">Mid Year remark:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearRemarks}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Appraiser Score</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearStatus}</Col>
                                                </Row>
                                            </Col>
                                            <Col sm={12}><hr/></Col>                                            
                                        </Row>
                                    )))}
                                   
                                    </CardBody>
                                </Card>
                                <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Short Term Development Needs ({mpaLines4.length})</h5>
                                    <CardBody>
                            
                             
                                    {(mpaLines4.map((i,k)=>(
                                        <Row key={k}>
                                        <Col lg={8} className="mb-3">
                                                <h5>Line {k+1}</h5>
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">Key Result Area:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.KeyResultArea}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Key Performance Indicator:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.KeyPerformanceIndicator}</Col>
                                                </Row>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <h5>&nbsp;</h5>
                                                {(phase == 'Mid-Year') && (whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && ( 
                                                <Row className='justify-content-center'>
                                                    <Col>
                                                        <div className="align-items-center">   
                                                            <Button
                                                                type="button"
                                                                color="info"
                                                                className="btn-sm btn-rounded m-3"
                                                                onClick={()=>handleClickLineDetails4(k)}
                                                                >
                                                                Appraiser ratings
                                                            </Button>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                )}  
                                                <Row  className="m-1 mb-4">
                                                    <Col sm={12}><h5 className="text-primary">Mid Year remark:</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearRemarks}</Col>
                                                </Row>
                                                <Row  className="m-1">
                                                    <Col sm={12}><h5 className="text-primary">Appraiser Score</h5></Col>
                                                    <Col sm={12}><i className="mdi mdi-chevron-right text-success me-1" />{" "}{i.MidYearStatus}</Col>
                                                </Row>
                                            </Col>
                                            <Col sm={12}><hr/></Col>  
                                        </Row>
                                    )))}
                                    </CardBody>
                                </Card>
                                <Card>
                                    <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Key Reflection Questions</h5>
                                    <CardBody>
                         
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>What should you start doing</label>
                                            <textarea rows={4} className="form-control" value={startDoing} onChange={(e)=>setStartDoing(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>What should you stop doing</label>
                                            <textarea rows={4} className="form-control" value={stopDoing} onChange={(e)=>setStopDoing(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>What should you continue doing</label>
                                            <textarea rows={4} className="form-control" value={continueDoing} onChange={(e)=>setContinueDoing(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Employee comment</label>
                                            <textarea rows={4} className="form-control" value={employeeComment} onChange={(e)=>setEmployeeComment(e.target.value)}  />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                            <label>Direct supervisor comment</label>
                                            <textarea rows={4} className="form-control" value={supervisorComment} onChange={(e)=>setSupervisorComment(e.target.value)}  />
                                            </div>
                                        </Col>
                                    </Row>
                                    {(phase == 'Mid-Year') && (whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && (
                                    <Row className="mb-2 mt-3 justify-content-center">
                                            <Col md={4} className='mb-3'>
                                                <div className="d-grid gap-2">
                                                    <Button
                                                        color="warning"
                                                        className="btn btn-rounded"
                                                        onClick={handleUpdatePA}
                                                        >
                                                        Save key reflection responses
                                                    </Button>
                                                </div>
                                            </Col>
                                    </Row>
                                    )}
                                    </CardBody>
                                    </Card>
                                    </Col>

                    <Col sm={3}></Col>
                    <Col sm="9">
                   

                                   
                     
                                <Row  className="justify-content-center">

                                    {reports.map((report, key)=>(  
                                <Col sm="4" key={key}>
                                    <Card>
                                        <CardBody>
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="avatar-xs me-3">
                                            <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                                                <i className={report.icon} />
                                            </span>
                                            </div>
                                            <h5 className="font-size-14 mb-0">{report.title}</h5>
                                        </div>
                                        <div className="text-muted mt-4">
                                            <h4>
                                            {report.value}{" "}
                                            <i className="mdi mdi-chevron-up ms-1 text-success" />
                                            </h4>
                                           
                                        </div>
                                        </CardBody>
                                    </Card>
                                    </Col>
                                    ))} 
                                </Row>
                                <Row  className="justify-content-center mb-3">
                               
                                {(phase == 'Mid-Year') && (whoAmI == 'appraiser') && (ipaStatus == 'Pending Approval') && (
                                    <>
                                        <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="primary" type="button" className="btn" onClick={handleConfirmMidTermJointReview} >
                                                    Confirm Mid term Joint Review
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="secondary" type="button" className="btn" onClick={handlePrint}>
                                                    {/* Print */}
                                                </Button>
                                            </div>
                                        </Col>
                                        
                                    </>
                                    
                                )}
                                {(phase == 'Mid-Year') && (whoAmI == 'appraisee') && (ipaStatus == 'Open')&& (
                                    <>
                                    <Col md={4}>
                                        <div className="d-grid gap-2">
                                            <Button color="primary" type="button" className="btn" onClick={handleSendMidtermToAppraiser} >    
                                                Send Midterm to appraiser
                                            </Button>
                                        </div>
                                    </Col>
                            
                                    <Col md={4}>
                                        <div className="d-grid gap-2">
                                            <Button color="secondary" type="button" className="btn" onClick={handlePrint}>
                                                {/* Print */}
                                            </Button>
                                        </div>
                                    </Col>
                                    </>
                                )}
                                {(phase == 'Mid-Year') && (whoAmI == 'appraisee') && (ipaStatus == 'Approved')&& (
                                    <>
                                    <Col md={4}>
                                        <div className="d-grid gap-2">
                                            <Button color="primary" type="button" className="btn" onClick={handleConvertToFullYear} >
                                                Convert to Full term appraisal
                                            </Button>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="d-grid gap-2">
                                            <Button color="secondary" type="button" className="btn" onClick={handlePrint}>
                                                {/* Print */}
                                            </Button>
                                        </div>
                                    </Col>
                                    </>
                                )}
                                    </Row>
                                                                     
                                    
                                    <br/>

                </Col>
                </Row>

                </div>


                
                   

            </Container>
        </div>
        </LoadingOverlay>
        );
    }

export default PADetails;